<template>
  <!-- 使用Element提供的container布局容器，这一块主要分为主要区域即可 -->
  <el-container>
    <el-header>
      <NavMenu></NavMenu>
    </el-header>
    <el-main>
      <BussIntr class="buss-area"></BussIntr>
    </el-main>
    <el-footer>
      <Footer></Footer>
    </el-footer>
  </el-container>
</template>

<script>
import NavMenu from "../common/NavMenu";
import BussIntr from "./BussIntr";
import Footer from "../common/Footer";
export default {
  name: "Bussiness",
  components: {
    NavMenu,
    BussIntr,
    Footer,
  },
};
</script>

<style lang="less" scoped>
/deep/.el-main {
  overflow: hidden !important;
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/BussinessIndex.vue